import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/": "ConciergePad - Home",
      "/dashboard": "ConciergePad - Dashboard",
      "/carline": "ConciergePad - Carline View"
    };

    document.title = titles[location.pathname] || "ConciergePad";
  }, [location]);

  return null; // This component does not render anything
};

export default PageTitle;